<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import localTransfers from "../stores/localTransfers";
    import R, {LOADER} from "../lib/requests";
    import {LOCAL_STATUS, LOCAL_STATUSES, LOCAL_TYPES} from "../lib/constants";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, getDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import DriverControl from "../components/controls/DriverControl.svelte";
    import LocationControl from "../components/controls/LocationControl.svelte";
    import DepartmentControl from "../components/controls/DepartmentControl.svelte";
    import LocalsTable from "./LocalsTable.svelte";
    import LocalsGrid from "./LocalsGrid.svelte";
    import DateControl from "../components/controls/DateControl.svelte";


    let pageHeaderControls = [
        {id: 'create', name: 'CREATE TRANSFER', link: '/app/new-local', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            link: '/app/new-local',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'search', name: '', icon: 'search'},
        {id: 'notifications', name: '', icon: 'bell'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const itemsPerPage = [20, 50, 100, 500];

    let localTypes = [];
    let localStatuses = [];
    let viewId = null;
    let showSearch = true;
    // EDO
    // let showSearch = false;

    const load = (loader = null) => {
        const onSuccess = result => {
            // preserve expanded transfers
            let expanded = [];
            if ($localTransfers.list) {
                $localTransfers.list.map(x => {
                    if (x.expanded) expanded.push(x.id);
                });
            }

            $localTransfers.list = result.transfers;
            $localTransfers.total = result.total;
            $localTransfers.location = result.location;

            $localTransfers.list.map(item => {
                item.date = formatDate(item.transfer_at, 'd-m-y');
                item.time = formatDate(item.transfer_at, 'H:i');
                if (!item.price) item.price = '';
                if (!item.arrival_time) item.arrival_time = '';
                item.expanded = expanded.indexOf(item.id) > -1;
            });
        }

        const onFailure = err => {
        };

        $localTransfers.changed = false;

        $localTransfers.search.status_id = `${$localTransfers.statusId}`;
        $localTransfers.search.offset = ($localTransfers.page - 1) * $localTransfers.search.limit;

        if (loader == null) {
            loader = LOADER.PAGE;
        }

        let search = copyObject($localTransfers.search);
        // EDO
        // if (!search.transfer_from) {
        //     search.transfer_from = getDate('y-m-d');
        //     search.page = null;
        //     search.limit = null;
        // }

        R.handle(R.localTransfer.index, search, onSuccess, onFailure, loader);
    }

    const search = () => {
        $localTransfers.page = 1;

        if ($localTransfers.search.transfer_from && $localTransfers.search.transfer_to && $localTransfers.search.transfer_from > $localTransfers.search.transfer_to) {
            $localTransfers.search.transfer_to = $localTransfers.search.transfer_from;
        }

        load();
    }

    const clearSearch = () => {
        localTransfers.clearSearch();
        load();
    }

    const onPageChange = ({detail}) => {
        $localTransfers.page = detail;
        load();
    }

    const onColumnSort = ({detail}) => {
        $localTransfers.search.sort_field = detail.key;
        $localTransfers.search.sort_way = detail.sort_way;
        load();
    }

    const onDriverChange = ({detail}) => {
        $localTransfers.search.driver_id = detail ? detail.id : null;
        search();
    }

    const onLocationChange = ({detail}) => {
        $localTransfers.search.location_id = detail ? detail.id : null;
        search();
    }

    const onDepartmentChange = ({detail}) => {
        $localTransfers.search.department_id = detail ? detail.id : null;
        search();
    }

    const onEdit = ({detail: local_id}) => {
        console.log("onEdit", local_id);
        $localTransfers.selectedId = local_id;
        $localTransfers.scrollY = window.scrollY;
        router.go(`/app/local/${local_id}`)();
    }

    const onView = ({detail: local_id}) => {
        console.log("onView", local_id);
        viewId = local_id;

        $localTransfers.selectedId = local_id;
        $localTransfers.scrollY = window.scrollY;
        router.go(`/app/local/${local_id}`)();
    }

    const onDelete = ({detail}) => {
        Alert.delete("Delete", `This will permanently delete local transfer.\nAre you sure?`, () => deleteTransfer(detail.id));
    }

    const deleteTransfer = (id) => {
        const onSuccess = result => {
            $localTransfers.list = $localTransfers.list.filter(x => x.id !== result);
            $localTransfers.total--;
            Notifier.showMessage("Local transfer deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.localTransfer.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const initialize = () => {
        Object.keys(LOCAL_STATUS).map(key => {
            localStatuses.push({id: LOCAL_STATUS[key], name: LOCAL_STATUSES[LOCAL_STATUS[key]]});
        });

        localTypes = [{id: '', name: 'type'}];
        Object.keys(LOCAL_TYPES).map(key => {
            localTypes.push({id: key, name: LOCAL_TYPES[key]});
        });

        if (!$localTransfers.list) {
            // EDO
            // if ($localTransfers.search.transfer_from) {
            //     $localTransfers.page = 1;
            //     $localTransfers.search.limit = itemsPerPage[0];
            // }

            $localTransfers.page = 1;
            $localTransfers.search.limit = itemsPerPage[0];

            load();
        }

        if ($localTransfers.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $localTransfers.scrollY});
                $localTransfers.scrollY = null;
            }, 50);

        }
    }

    initialize();

    const setNotifications = (value) => {
        if ('Notification' in window) {
            // API supported
            if (value && Notification.permission !== "granted") {
                Notification.requestPermission(status => {
                    if (status === 'granted') {
                        Notifier.showMessage("Notifications enabled!");
                    } else {
                        Notifier.showError("Could not enable notifications!");
                    }
                    $localTransfers.notifications = status === 'granted';
                });
            } else {
                $localTransfers.notifications = value;
            }
        } else {
            // API not supported
        }
        let control = pageHeaderControls.find(x => x.id === 'notifications');
        control.icon = $localTransfers.notifications ? 'bell' : 'bell-off';
        pageHeaderControls = pageHeaderControls;
    }

    if ('Notification' in window) {
        $localTransfers.notifications = Notification.permission === "granted";
        setNotifications($localTransfers.notifications);
    }

    $: {
        if ($localTransfers.changed) {
            load(LOADER.NONE);
        }
    }
</script>
<PageHeader title="Locals" controls={ pageHeaderControls }
            on:search={ () => showSearch = !showSearch }
            on:notifications={ () => setNotifications(!$localTransfers.notifications) }
            on:reload={ load }/>

{#if showSearch}
    <div class="transfer-filters panel-filters mb-5">
        <div class="d-xl-flex border-bottom-dotted">
            <div class="d-xl-flex d-lg-flex d-md-flex">
                <div class="d-flex dates text-gray ">
                    <div class="filter-col d-flex align-items-center">
                        <div class="hidden-xs pe-2">Date</div>
                        <DateControl placeholder="transfer date" bind:value="{ $localTransfers.search.transfer_from }"
                                     on:change="{ search }"/>
                        <!--                        <input type="date" class="form-control date px-1"-->
                        <!--                               bind:value="{ $localTransfers.search.transfer_from }"-->
                        <!--                               on:change="{ search }">-->
                    </div>
                    <div class="filter-col d-flex align-items-center">
                        <div class="hidden-xs pe-2">to</div>
                        <DateControl placeholder="to" bind:value="{ $localTransfers.search.transfer_to }"
                                     on:change="{ search }"/>
                        <!--                        <input type="date" class="form-control date px-1"-->
                        <!--                               bind:value="{ $localTransfers.search.transfer_to }"-->
                        <!--                               on:change="{ search }">-->
                    </div>
                </div>
                <div class="d-flex  states">
                    <div class="filter-col ">
                        <select class="form-select" bind:value="{ $localTransfers.search.type_id }"
                                on:change="{ search }">
                            {#each localTypes as item}
                                <option value="{ item.id }">{ item.name }</option>
                            {/each}
                        </select>
                    </div>
                    <div class="filter-col">
                        <select class="form-select" bind:value="{ $localTransfers.statusId }"
                                on:change="{ search }">
                            <option value="">status</option>
                            {#each localStatuses as item}
                                <option value="{ item.id }">{ item.name }</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-xl-flex d-lg-flex d-md-flex">
            <div class="d-xl-flex d-lg-flex d-md-flex more">
                <div class="filter-col ">
                    <DriverControl driver={$localTransfers.driver} css="px-2" placeholder="driver"
                                   on:change={ onDriverChange }/>
                </div>
                <div class="filter-col ">
                    <LocationControl location={$localTransfers.location} css="px-2" placeholder="location"
                                     on:change={ onLocationChange }/>
                </div>
                <div class="filter-col">
                    <DepartmentControl bind:department={$localTransfers.department} css="px-2"
                                       placeholder="department" on:change={ onDepartmentChange }/>
                </div>
            </div>
            <div class="d-flex buttons justify-content-end">
                <div class="filter-col">
                    <button class="btn btn-default" on:click="{ clearSearch }">CLEAR</button>
                </div>
                <div class="filter-col">
                    <button class="btn btn-outline" on:click="{ search }">SEARCH</button>
                </div>
            </div>
        </div>
    </div>
{/if}
<!-- EDO -->
<!--{#if $localTransfers.search.transfer_from || $localTransfers.search.transfer_to }-->
<div class="mb-4">
    <div class="row">
        <div class="col-xl-2">
            <select class="form-select form-select-sm" bind:value="{ $localTransfers.search.limit }"
                    on:change="{ search }">
                {#each itemsPerPage as item}
                    <option value="{ item }">display { item } / page</option>
                {/each}
            </select>
        </div>
    </div>
</div>
<!--{/if}-->

{#if $localTransfers.list}
    {#if $localTransfers.list.length}
        {#if $app.device === 'lg' || $app.device === 'md'}
            <LocalsTable on:sort="{ onColumnSort }"
                         on:edit="{ onEdit }"
                         on:view="{ onView }"
                         on:delete="{ onDelete }"/>
        {:else}
            <LocalsGrid on:sort="{ onColumnSort }"
                        on:edit="{ onEdit }"
                        on:view="{ onView }"
                        on:delete="{ onDelete }"/>
        {/if}
        {#if $localTransfers.search.limit}
            <Pagination itemsPerPage="{ $localTransfers.search.limit }" totalItems="{ $localTransfers.total }"
                        page="{ $localTransfers.page }"
                        on:change="{ onPageChange }"/>
        {/if}
    {:else}
        <div class="panel border-default">
            <div class="panel-body panel-pad">
                No local transfers found.
            </div>
        </div>
    {/if}
{/if}


<style>
    .transfer-filters {

    }

    @media (max-width: 576px) {
        .transfer-filters .dates .filter-col {
            width: 50%;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }
    }

    /* Small devices (landscape phones, 576px and up) */
    @media (max-width: 767px) {
        .transfer-filters .dates.border-after:after, .transfer-filters .states.border-after:after {
            display: none;
        }
    }

    /* Medium devices (tablets, 768px and up) (col-sm) */
    @media (min-width: 768px) and (max-width: 991px) {
        .transfer-filters .date {
            width: 130px;
        }

        .transfer-filters .states {
            width: calc(100% - 410px);
        }

        .transfer-filters .states.border-after:after {
            display: none;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }
    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) and (max-width: 1199px) {
        .transfer-filters .date {
            width: 130px;
        }

        .transfer-filters .states {
            width: calc(100% - 410px);
        }

        .transfer-filters .states.border-after:after {
            display: none;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }

        .transfer-filters .more {
            width: 100%;
        }

        .transfer-filters .more .filter-col {
            width: 33.33333333%;
        }
    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
        .transfer-filters .date {
            width: 130px;
        }

        /*.transfer-filters .states .filter-col {*/
        /*    width: 50%;*/
        /*}*/
        .transfer-filters .customer {
            width: calc(100% - 688px);
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }

        .transfer-filters .more {
            width: 100%;
        }

        .transfer-filters .more .filter-col {
            width: 33.33333333%;
        }
    }
</style>

